import React, { useRef } from 'react';
import { Line } from 'react-chartjs-2';
// import Button from '@mui/material/Button'; // Import Button from Material-UI
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';
import { Padding } from '@mui/icons-material';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const DateTimeGraph = ({ data = {} }) => {
  const chartRef = useRef(null);
  const seriesData = Object.entries(data).map(([date, value]) => {
    const timestamp = new Date(date).getTime();
    return [timestamp, value];
  });
  const formattedData = seriesData.map(([timestamp, value]) => ({
    timestamp,
    date: new Date(timestamp).toLocaleDateString("en-GB", { day: "2-digit", month: "short" }), // ONLY date + month for X-axis
    fullDate: new Date(timestamp).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }), // Full date for tooltip
    value
  }));
  const getGradient = (ctx, chartArea) => {
    const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
    gradient.addColorStop(0, 'rgba(25, 118, 210, 0.3)'); // Blue, more opaque at the top
    gradient.addColorStop(1, 'rgba(255,255,255,1)');   // Almost white/transparent at the bottom
    return gradient;
  };
  const maxLabels = 10; // Show at most 10 labels on x-axis
  const totalPoints = formattedData.length;
  const step = Math.ceil(totalPoints / maxLabels);
  const dateData = {
    labels: formattedData.map((item, index) =>
      index % step === 0 ? item.date : '' // Only show every step-th label
    ),
    datasets: [
      {
        label: 'No. of consumption',
        data: formattedData.map(item => item.value),
        borderColor: '#1976D2', // Blue line
        fill: true,
        tension: 0.4, // Smooth curve
        pointRadius: 0,
        pointHitRadius: 10,
        pointBackgroundColor: '#1976D2',
        borderWidth: 4,
        pointBorderColor: '#fff',
        pointHoverRadius: 7,
        pointHoverBackgroundColor: '#1976D2',
        pointHoverBorderColor: '#1976D2',
        backgroundColor: function(context) {
          const chart = context.chart;
          const {ctx, chartArea} = chart;
          if (!chartArea) return null;
          return getGradient(ctx, chartArea);
        }
      },
    ],
  };
  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        backgroundColor: '#fff',
        borderColor: '#e0e0e0',
        borderWidth: 1,
        titleColor: '#212121',
        bodyColor: '#212121',
        titleFont: {size: 14 },
        bodyFont: { size: 12 },
        padding: 12,
        callbacks: {
          title: function(context) {
            const index = context[0].dataIndex;
            const fullDate = formattedData[index].fullDate; 
            return fullDate;
          },
          label: function(context) {
            return `No. of consumption : ${context.parsed.y}`;
          }
        }
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#212121',
          font: {
            size: 14,
          },
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false,
        },
      },
      y: {
        grid: {
          color: 'rgba(25, 118, 210, 0.08)',
        },
        ticks: {
          color: '#212121',
          font: {
            size: 14,
          },
        },
      },
      
    },
  };
  
  return (
    <div>
      <Line ref={chartRef} data={dateData} options={options} height={260} />    
    </div>
  );
};

export default DateTimeGraph;
 